import TaTransactionOrder from './TaTransactionOrder'

export default TaTransactionOrder
